<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Toli Level productivity </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                
                                <li class="breadcrumb-item"><a href="#">Reports</a>
                            </li>
                            
                            <li class="breadcrumb-item active"> Analysis
                            </li>
                            <li class="breadcrumb-item active">Toli level 
                            </li>
                            
                            </ol>
                        </div>
                    </div>
                    </div>
                </div>
            
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
                     <div class="card">
                        <div class="card-header py-1 filter_card_searchbgst_dock filter_rotation_onlick ">
                            <div class="container-fluid" @click="toggleCollapse">
                                <div class="row row fc_my-05">
                                     <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex">
                                            <div class="avatar-content">
                                                <em data-feather='search' class="custom-class avatar-icon font-medium-3"></em>
                                            </div>
                                        </div>
                                     </div>
                                    <h4 class="card-title d-inline-flex ml-1"> Search Toli Level productivity </h4>
                                </div>
                            </div>
                           
                        </div>
                        <div  v-if="isCollapsed" class="collapsed-div mb-0">
                            <div class="card-body pt-1">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">Staff ID</label>
                                        <treeselect placeholder="Select User/Staff Name" v-model="search.created_by" :options="search.created_by_list"  />
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">From Date</label>
                                        <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">To Date</label>
                                        <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">Gate Type</label>
                                        <treeselect placeholder="Select Gate Type"  />
                                       
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">Gate Type</label>
                                        <treeselect placeholder="Select Gate Type"  />
                                       
                                    </div> -->
                                    <div class="col-12 col-sm-6 col-md-6  col-lg-3 text-right mb-1 all_buttons_style">
                                        <button type="submit" class="btn btn-relief-warning mt-2 mr-1" @click="getReports('report', search)">
                                            Search
                                        </button>
                                        <button type="submit" class="btn btn-relief-secondary mt-2 " @click="resetFilters">
                                            clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div>
                       <div class="px-0">
                        <div class="col-lg-12 mt-0 px-0">
                            <div class="card text-center mb-1">
                                <!-- <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="report" aria-labelledby="report_tab" aria-expanded="true"> -->
                                            <div class="container px-0" >
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-hover table_stickys table-striped table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left align-middle">Superwiser Name</th>
                                                                <th class="text-left align-middle">Vehicle Loading Count</th>
                                                                <th  class="text-left align-middle">Vehicle Un-Loading Count</th>
                                                                <th  class="text-left align-middle">Dock Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <vue-element-loading :active="isReportDataLoading" />
                                                            <template v-for="(data,index) in report.list"  >
                                                                <tr @click="toggle(String(data.created_by))">
                                                                    <td data-column="Superwiser Name" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Vehicle Loading Count" class="text-left">{{data.vehicle_loading_count}}</td>
                                                                    <td data-column="Vehicle Un-Loading Count" class="text-left">{{data.vehicle_unloading_count}}</td>
                                                                    <td data-column="Dock Time" class="text-left">{{convertMinutesToTime2(data.dock_time)}}</td>
                                                                </tr>
                                                                <tr v-if="opened === String(data.created_by)"  :class="{ opened: opened === String(data.created_by)}" >
                                                                    <vue-element-loading :active="isShipmentsLoading" />
                                                                        <td colspan="100%" style="padding: 0px!important;">
                                                                        <div class="table-responsive datatableview" style="padding: 10px!important;">
                                                                            <table class="opened table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-left align-middle">Date</th>
                                                                                        <th class="text-left align-middle">Vehicle Loading Count</th>
                                                                                        <th class="text-left align-middle">Vehicle Un-Loading Count</th>
                                                                                        <th class="text-left align-middle">Dock Time</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <template v-for="(ship, idx) of shipmentData">
                                                                                        <tr>
                                                                                            <td data-column="Date" class="text-left">
                                                                                                {{ship.date}}
                                                                                            </td>
                                                                                            <td data-column="Vehicle Loading Count" class="text-left">
                                                                                                {{ship.vehicle_loading_count}}
                                                                                            </td>
                                                                                            <td data-column="Vehicle Un-Loading Count" class="text-left">
                                                                                                {{ship.vehicle_unloading_count}}
                                                                                            </td>
                                                                                            <td data-column="Dock Time" class="text-left">
                                                                                                {{convertMinutesToTime2(ship.dock_time)}}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                    <template v-if="!shipmentData.length">
                                                                                      <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                                                    </template>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!report.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="report.page" :records="report.totalcount" :per-page="report.pagelimit" @paginate="(e) => handlePageChange(e, 'report')"/>
                                                </div>
                                            </div>
                                        <!-- </div> -->
                                        <!-- <div role="tabpanel" class="tab-pane" id="chart" aria-labelledby="chart_tab" aria-expanded="false">
                                            <BarChart :chartData="chartData" />
                                            <hr />
                                            <PieChart :chartData="pieChartData" />
                                        </div> -->
                                    <!-- </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../../constants.js"
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import BarChart from "./Charts/BarChart.vue"
import PieChart from "./Charts/PieChart.vue"

export default({
    name:'ToliLeveleProductivity',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        BarChart,
        PieChart,
    },
    data() {
        return {
            isLoading: false,
            isShipmentsLoading: false,
            isReportDataLoading: false,
            isReportActive: true,
            reportData: [],
            shipmentData: [],
            dock_time: [],
            opened: null,
            isCollapsed: false,
            search: {
                created_by_list: [],
                created_by: null,
                start_date: null,
                end_date: null
            },
            report: {
                url: "/reports/tolli-level-productivity",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
            },
        }
    } ,
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getReports()
        this.getCreatedByList()
        // this.getDataForAnalysis()
        // this.getPieChartDataForAnalysis()
    },
    methods: {
        resetFilters() {
            this.search.created_by = null
            this.report.currPageNum = 0
            this.report.page = 1
            this.report.pageoffset = 1
            this.search.start_date = null
            this.search.end_date = null
            this.getReports()
        },
        getCreatedByList() {
            this.searchNameMasterList('dock_entry_scan', 'created_by', null, 'created_by')
                .then(result => {
                    console.log(result.data)
                  this.search.created_by_list = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        getDockTime(gate_entry_id) {
            if(!gate_entry_id)  return '-'
            let entries = gate_entry_id.split(",").map(i => Number(i))
            let time = 0
            for(let entry of entries) {
                let entry_time = this.dock_time.find(d => d.gate_entry_id == entry)
                if(entry_time) {
                    time += entry_time.time
                }
            }
            return time
        },
        toggle(id) {
            const isOpen = this.opened === id;
            if(isOpen) {
                this.opened = null
            } else {
                this.opened = id
                this.isShipmentsLoading = true
                let created_by = id
                let url = `/reports/${created_by}/tolli-level-productivity`
                this.shipmentData = []
                this.makeRequest("POST", url, {
                    start_date: this.search.start_date,
                    end_date: this.search.end_date
                })
                    .then(result => {
                        this.isShipmentsLoading = false
                        this.shipmentData = result.data
                    })
                    .catch(e => {
                        this.isShipmentsLoading = false
                        this.displayError(e)
                    })
            }
        },
        activateReport() {
            this.isReportActive = true
        },
        deActivateReport() {
            this.isReportActive = false
        },
        getReports(tab="report", search={}) {
            this.isReportDataLoading = true
            let payload = {
                page: this[tab].page,
                rows: this[tab].pagelimit,
                created_by: search.created_by,
                start_date: this.search.start_date,
                end_date: this.search.end_date
            }
            if(this.search.start_date || this.search.end_date) {
                this.opened = null
            }
            this.makeRequest("POST", this[tab].url, payload)
                .then(result => {
                    this.isReportDataLoading = false
                    let data = result.data.data.rows                    
                    this[tab].list = data
                    this[tab].totalcount = result.data.data.count
                    this[tab].pageCount = Math.ceil(result.data.data.count / this[tab].pagelimit)
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        handlePageChange(pageNum, tab) {
            this[tab].pageoffset=pageNum
            this[tab].currPageNum = pageNum - 1

            this.getReports(tab, this.search);
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
.opened {
  background-color: #e3fafc;
}
.btn--export {
    border: none;
    padding: 6px 12px;
    color: #000;
    background: #fff;
    font-weight: 500
}
.btn--export:hover {
    color: #fff;
    background: #000
}
</style>